import { useState } from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    // JCSPay - Payment Gateway
    { 
      question: "What is JCSPay and how does it work?",
      answer: "JCSPay is a secure payment gateway that enables businesses and individuals to process transactions seamlessly. It supports multiple payment methods including credit/debit cards and digital wallets."
    },
    { 
      question: "Is JCSPay secure for online transactions?",
      answer: "Yes, JCSPay is fully encrypted with industry-standard security protocols, ensuring safe and secure online payments."
    },
    { 
      question: "How can I integrate JCSPay into my website?",
      answer: "You can integrate JCSPay using our developer-friendly APIs. We provide detailed documentation for easy setup."
    },
    { 
      question: "Are there any transaction fees for using JCSPay?",
      answer: "Yes, JCSPay charges a small processing fee per transaction. The exact fee depends on the type of transaction and volume."
    },

    // Electronics Trading
    { 
      question: "What types of electronic products do you offer?",
      answer: "We offer a wide range of electronic products, including consumer electronics, industrial equipment, and smart devices."
    },
    { 
      question: "Do you provide bulk purchasing options for businesses?",
      answer: "Yes, we offer bulk purchasing with special discounts for businesses looking to buy electronics in large quantities."
    },
    { 
      question: "Can I return or exchange electronic items?",
      answer: "Yes, we have a return and exchange policy. Items can be returned within 15 days if they meet the return criteria."
    },

    // Smart Systems
    { 
      question: "What smart solutions do you provide?",
      answer: "We provide IoT-based smart automation solutions for businesses, homes, and industrial applications."
    },

    // Innovative Intelligence Solutions
    { 
      question: "How does your innovative intelligence help businesses?",
      answer: "Our AI-powered solutions enhance business operations through automation, predictive analytics, and smart decision-making tools."
    },

    // Gift Cards & Value-added Services
    { 
      question: "What value-added services do you offer?",
      answer: "Our value-added services include gift card distribution, loyalty programs, and mobile top-up services."
    },

    // Call Centers & Empowerment
    { 
      question: "How does your call center service work?",
      answer: "We provide professional call center solutions, helping businesses handle customer interactions effectively with trained agents and advanced CRM tools."
    },

    // Networking Services
    { 
      question: "What network services do you provide?",
      answer: "We offer comprehensive networking solutions, including setup, maintenance, and security enhancements for businesses and individuals."
    },
    { 
      question: "Do you provide networking consultation services?",
      answer: "Yes, our experts offer consultation services to help businesses design and implement efficient and secure network infrastructures."
    },
    { 
      question: "Can you assist with network security solutions?",
      answer: "Absolutely! We provide advanced security solutions, including firewalls, VPNs, and intrusion detection systems to protect your network."
    }
  ];

  return (
    <div>
    <Fixed />
    <div className="min-h-screen py-16 px-6 bg-gray-50 text-gray-900 pt-32">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gray-800">Frequently Asked Questions</h1>
        <p className="text-lg text-center text-gray-600 mt-4">Find answers to common questions about our services.</p>

        <div className="mt-10 space-y-6">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white shadow-lg rounded-lg overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center p-5 text-lg font-medium text-gray-800 hover:bg-gray-100"
              >
                {faq.question}
                <span>{openIndex === index ? "−" : "+"}</span>
              </button>
              {openIndex === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{ duration: 0.3 }}
                  className="p-5 text-gray-700 bg-gray-100"
                >
                  {faq.answer}
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
    <Footer1 />
    </div>
  );
}
